import axiosInstance from './axiosInstance';

// Exams
export const listExams = (params) => axiosInstance.get('/admin/exams', { params });
export const getExam = (id) => axiosInstance.get(`/admin/exams/${id}`);
export const createExam = (data) => axiosInstance.post('/admin/exams', data);
export const updateExam = (id, data) => axiosInstance.put(`/admin/exams/${id}`, data);
export const deleteExam = (id) => axiosInstance.delete(`/admin/exams/${id}`);
export const togglePublish = (id) => axiosInstance.patch(`/admin/exams/${id}/publish`);
export const cloneExam = (id) => axiosInstance.post(`/admin/exams/${id}/clone`);
export const getAllCandidates = () => axiosInstance.get('/admin/exams/candidates');
export const getExamCandidates = (examId) => axiosInstance.get(`/admin/exams/${examId}/candidates`);
export const assignCandidates = (examId, candidateIds) => axiosInstance.put(`/admin/exams/${examId}/candidates`, { candidateIds });

// Questions
export const listQuestions = (examId) => axiosInstance.get(`/admin/exams/${examId}/questions`);
export const addQuestion = (examId, data) => axiosInstance.post(`/admin/exams/${examId}/questions`, data);
export const updateQuestion = (examId, qid, data) => axiosInstance.put(`/admin/exams/${examId}/questions/${qid}`, data);
export const deleteQuestion = (examId, qid) => axiosInstance.delete(`/admin/exams/${examId}/questions/${qid}`);
export const reorderQuestions = (examId, data) => axiosInstance.patch(`/admin/exams/${examId}/questions/reorder`, data);
export const bulkUpload = (examId, file) => {
  const form = new FormData();
  form.append('file', file);
  return axiosInstance.post(`/admin/exams/${examId}/questions/bulk-upload`, form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

// Candidates
export const bulkInviteCandidates = (file, examId) => {
  const form = new FormData();
  form.append('file', file);
  form.append('examId', examId);
  return axiosInstance.post('/admin/candidates/bulk-invite', form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};
export const getAllExams = () => axiosInstance.get('/admin/exams/all');
export const getCandidates = (params) => axiosInstance.get('/admin/candidates', { params });
export const deactivateCandidate = (id) => axiosInstance.patch(`/admin/candidates/${id}/deactivate`);

// Results
export const overrideResult = (resultId, data) => axiosInstance.patch(`/admin/results/${resultId}/override`, data);

// Reports
export const getDashboardStats = () => axiosInstance.get('/admin/reports/dashboard/stats');
export const getExamResults = (examId, params) => axiosInstance.get(`/admin/reports/exams/${examId}/results`, { params });
export const getResultDetail = (examId, resultId) => axiosInstance.get(`/admin/reports/exams/${examId}/results/${resultId}`);
export const exportCsv = (examId) => axiosInstance.get(`/admin/reports/exams/${examId}/export/csv`, { responseType: 'blob' });
export const exportPdf = (examId) => axiosInstance.get(`/admin/reports/exams/${examId}/export/pdf`, { responseType: 'blob' });
export const getSessionActivity = (sessionId) => axiosInstance.get(`/admin/reports/sessions/${sessionId}/activity`);

// Audit logs
export const getAuditLogs = (params) => axiosInstance.get('/admin/audit-logs', { params });

// Question bank
export const getBankQuestions = (params) => axiosInstance.get('/admin/question-bank', { params });
export const getBankQuestion = (id) => axiosInstance.get(`/admin/question-bank/${id}`);
export const createBankQuestion = (data) => axiosInstance.post('/admin/question-bank', data);
export const updateBankQuestion = (id, data) => axiosInstance.put(`/admin/question-bank/${id}`, data);
export const deleteBankQuestion = (id) => axiosInstance.delete(`/admin/question-bank/${id}`);
export const bulkUploadBankQuestions = (file) => {
  const fd = new FormData();
  fd.append('file', file);
  return axiosInstance.post('/admin/question-bank/bulk-upload', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
};
export const getExamBankQuestions = (examId) => axiosInstance.get(`/admin/exams/${examId}/bank-questions`);
export const addBankQuestionToExam = (examId, bankQuestionId) => axiosInstance.post(`/admin/exams/${examId}/bank-questions/${bankQuestionId}`);
export const removeBankQuestionFromExam = (examId, bankQuestionId) => axiosInstance.delete(`/admin/exams/${examId}/bank-questions/${bankQuestionId}`);

// Manual grading
export const getPendingGrading = (examId) => axiosInstance.get(`/admin/exams/${examId}/grading`);
export const gradeAnswer = (answerId, score) => axiosInstance.patch(`/admin/answers/${answerId}/grade`, { score });
